import { render, staticRenderFns } from "./AppCaptura.vue?vue&type=template&id=35e563ee&"
import script from "./AppCaptura.vue?vue&type=script&lang=js&"
export * from "./AppCaptura.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports